"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkServiceDefault = void 0;
var tslib_1 = require("tslib");
/**
 * Represents a network session for making HTTP requests.
 * @class
 * Implements the NetworkSession interface.
 */
var NetworkServiceDefault = /** @class */ (function () {
    function NetworkServiceDefault() {
    }
    /**
     * Fetches data from the specified URL.
     * @param requestable - The object.
     * @returns A promise that resolves to the fetched data.
     */
    NetworkServiceDefault.prototype.fetch = function (requestable) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urlToUse, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlToUse = requestable.url;
                        return [4 /*yield*/, fetch(urlToUse, {
                                method: requestable.method,
                                headers: tslib_1.__assign({ 'Content-Type': 'application/json' }, requestable.headers),
                                cache: 'no-store',
                                body: requestable.body ? JSON.stringify(requestable.body) : null,
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return NetworkServiceDefault;
}());
exports.NetworkServiceDefault = NetworkServiceDefault;
